module.exports = __webpack_public_path__ + "img/senegal.f5514f58.png";